module.exports = __webpack_public_path__ + "img/btn_follow.055d567f.svg";